// extracted by mini-css-extract-plugin
export var orderSummary = "_ow-0";
export var showMoreLessButton = "_ow-1";